module.exports = __webpack_public_path__ + "static/img/10006 (2).4f714cb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10006 (2).webp
// module id = R5ak
// module chunks = 14